const { externalEMR } = (window as any).config

export class ExternalEmr {
  public static getUrlPatient(externalId: string | undefined) {
    const urlPatient = `${externalEMR}${externalId}`

    return urlPatient
  }
}
